import { render, staticRenderFns } from "./MPlayYoutube.vue?vue&type=template&id=168d3aa0&scoped=true&"
import script from "./MPlayYoutube.vue?vue&type=script&lang=js&"
export * from "./MPlayYoutube.vue?vue&type=script&lang=js&"
import style0 from "./MPlayYoutube.vue?vue&type=style&index=0&id=168d3aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168d3aa0",
  null
  
)

export default component.exports